<script>
export default {
  name: 'CopyInvoiceButton',
  props: {
    onClick: {
      type: Function,
      required: true
    }
  }
}
</script>

<template>
  <div class="button btn btn-success copy-invoice-button" @click.prevent="onClick">
    <span class="material-symbols-outlined copy-icon">content_copy</span>
    Copy
  </div>
</template>

<style scoped lang="scss">
.copy-invoice-button {
  display: inline-block;
  min-width: 100px;
}

.copy-icon {
  font-size: 15px;
  vertical-align: text-bottom;
}
</style>
